import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { FrontendFilterValue, SelectedFilters } from '../../types/filters.type';
import { setFilters, toggleFilter } from '../../utils/filters';

export interface FilterStoreState {
  selectedFilters: SelectedFilters
  setSelectedFilters: (title: string, dropownKey: string, filterDisplayName: string, options: FrontendFilterValue[]) => void;
  toggleSelectedFilter: (title: string, dropdownKey: string, filterDisplayName: string, option: FrontendFilterValue) => void;
  updateFilterStore: (newFilters: SelectedFilters) => void
  clearAllFilters: () => void;
  getActiveFilters: () => Record<string, any>;
}

const sessionStorageName = 'filter-store';
const useFilterStore = create<FilterStoreState>()(
  // persist store state in sessionStorage
  persist(
    (set, get) => ({
      selectedFilters: {},
      setSelectedFilters: (title, dropdownKey, filterDisplayName, options) => set((state) => setFilters(title, dropdownKey, filterDisplayName, options, state.selectedFilters)),
      toggleSelectedFilter: (title, dropdownKey, filterDisplayName, option) => set((state) => toggleFilter(title, dropdownKey, filterDisplayName, option, state.selectedFilters)),
      updateFilterStore: (newFilters) => set(() => ({
        selectedFilters: newFilters,
      })),
      clearAllFilters: () => {
        set(() => ({
          selectedFilters: {},
        }));
        sessionStorage.removeItem(sessionStorageName);
      },
      getActiveFilters: () => {
        const state = get();
        const result: Record<string, Record<string, string[]>> = {};
        Object.entries(state.selectedFilters).forEach(([title, dropdowns]) => {
          if (!result[title]) {
            result[title] = {};
          }
          Object.entries(dropdowns).forEach(([key, values]) => {
            if (values.selectedValues.length > 0) {
              result[title][key] = [...values.selectedValues].map((value) => value.displayName);
            }
          });
        });

        return result;
      },
    }),
    {
      name: sessionStorageName,
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

export default useFilterStore;
